import React from 'react';
import Navigation from '../Shared/Navigation/Navigation';
import InvestorBanner from './InvestorBanner/InvestorBanner';

const InvestorForm = () => {
    return (
        <div>
            <Navigation></Navigation>
            <InvestorBanner></InvestorBanner>
        </div>
    );
};

export default InvestorForm;